var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterfall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Waterfall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "waterfall-a",
    d: "M0 0h56v56H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M13 43.58V10.5C13 5.366 10.371 3 4.5 3a1.5 1.5 0 0 1 0-3h30C41.962 0 46 3.634 46 10.5v32.639a14.956 14.956 0 0 0-3-1.598V10.5c0-4.553-2.067-6.93-6.63-7.409C38.101 4.842 39 7.323 39 10.5a1.5 1.5 0 0 1-3 0c0-4.636-2.284-7.028-7.34-7.437C30.204 4.823 31 7.318 31 10.5v6a1.5 1.5 0 0 1-3 0v-6c0-4.858-2.054-7.207-6.59-7.474C23.116 4.782 24 7.287 24 10.5v15a1.5 1.5 0 0 1-3 0v-15c0-4.863-2.358-7.242-7.595-7.48C15.114 4.777 16 7.284 16 10.5v33.74a13.966 13.966 0 0 0-3-.66zM28 25.5a1.5 1.5 0 0 1 3 0v9a1.5 1.5 0 0 1-3 0v-9zm-7 13a1.5 1.5 0 0 1 3 0v4a1.5 1.5 0 0 1-3 0v-4zm15-21a1.5 1.5 0 0 1 3 0v6a1.5 1.5 0 0 1-3 0v-6z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "waterfall-b",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#waterfall-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M28.391 51.366l-.49 1.08-1.165-.229A11.564 11.564 0 0 0 24.5 52c-1.383 0-2.73.244-3.998.714l-1.063.394-.67-.915a9 9 0 1 0-6.592 14.282l1.131-.084.39 1.064a11.504 11.504 0 0 0 21.883-.866l.318-1.145 1.188.048a10.201 10.201 0 0 0 1.108-.016l.547-.037.442.324A8.952 8.952 0 0 0 44.5 67.5a9 9 0 0 0 9-9c0-4.378-3.148-8.1-7.407-8.86l-.54-.096-.351-.423A9.974 9.974 0 0 0 37.5 45.5a10 10 0 0 0-9.109 5.866zM37.5 42.5a12.97 12.97 0 0 1 9.655 4.295A12.004 12.004 0 0 1 56.5 58.5c0 6.627-5.373 12-12 12a11.95 11.95 0 0 1-6.434-1.869 14.507 14.507 0 0 1-26.771.867C4.762 69.388-.5 64.058-.5 57.5c0-6.627 5.373-12 12-12 3.499 0 6.747 1.51 8.998 4.06a14.508 14.508 0 0 1 5.686-.463A12.998 12.998 0 0 1 37.5 42.5z",
    mask: "url(#waterfall-b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfall);
export default __webpack_public_path__ + "static/media/waterfall.20818f9fca029faf23e2381e9d7dcf93.svg";
export { ForwardRef as ReactComponent };